export enum InvoiceSettingEnvironment {
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION',
}

export enum TaxAssessmentRegime {
  ByTheSimplesNational = 'BY_THE_SIMPLES_NATIONAL',
  ByTheSimplesNationalIssqnOnTheOutside = 'BY_THE_SIMPLES_NATIONAL_ISSQN_ON_THE_OUTSIDE',
  SimplesNationalOnTheOutside = 'SIMPLES_NATIONAL_ON_THE_OUTSIDE',
}
